export default [
  { to: 'oppenvard', title: 'Öppenvård' },
  { to: 'profylax', title: 'Profylax' },
  { to: 'tandvard', title: 'Tandvård' },
  { to: 'slutenvard', title: 'Slutenvård' },
];
